import React, { useState } from "react";
import {
  Box,
  Container,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Stack
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import { uploadFormPhd } from "../../core/service/uploadForm.service";
import { useSelector } from "react-redux";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import UploadFormInfo from "./Forms/UploadFormInfo";
import UploadFormPage1_3year from "./Forms/UploadFormPage1_3year";
import UploadFormPage1_5year from "./Forms/UploadFormPage1_5year";
import UploadFormPage2A from "./Forms/UploadFormPage2A";
import UploadFormPage2B from "./Forms/UploadFormPage2B";
import UploadFormPage2C from "./Forms/UploadFormPage2C";

import Page404 from "../Page404";

import validationSchema from "./FormModel/validationSchema";
import PhDUploadFormModel from "./FormModel/PhDUploadFormModel";
import formInitialValues from "./FormModel/formInitialValues";

let steps = ["Page Info", "Page1", "Page2"];
const FORM_2A = "2a";
const FORM_2AB = "2ab";
const FORM_2C = "2c";
const { formId, formField } = PhDUploadFormModel;

const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";

function _renderStepContent(step, checkFormPage, role) {
  if (checkFormPage === FORM_2AB) {
    if (steps.length === 3) {
      steps.push("Page3");
    }
  } else {
    let index = steps.indexOf("Page3");
    if (index !== -1) {
      steps.splice(index, 1);
    }
  }

  switch (step) {
    case 0:
      return <UploadFormInfo formField={formField} />;
    case 1:
      return role === ROLE_PHD_3Y ? (
        <UploadFormPage1_3year formField={formField} />
      ) : (
        <UploadFormPage1_5year formField={formField} />
      );
    case 2:
      return checkFormPage === FORM_2A ? (
        <UploadFormPage2A formField={formField} />
      ) : checkFormPage === FORM_2AB ? (
        <UploadFormPage2A formField={formField} />
      ) : (
        checkFormPage === FORM_2C && <UploadFormPage2C formField={formField} />
      );
    case 3:
      return <UploadFormPage2B formField={formField} />;
    default:
      return <Page404 />;
  }
}

export default function UploadFormPhD() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user: currentUser, role } = useSelector((state) => state.authReducer);
  const { pagePhd } = useSelector((state) => state.uploadFormReducer);

  const [activeStep, setActiveStep] = useState(0);
  // const currentValidationSchema = validationSchema[activeStep];
  const currentValidationSchema = validationSchema(pagePhd, activeStep, role);
  const isLastStep = activeStep === steps.length - 1;

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function _submitForm(values, actions) {
    var formData = new FormData();

    await _sleep(1000);
    // console.log(JSON.stringify(values, null, 2));
    actions.setSubmitting(false);

    for (const [key, value] of Object.entries(values)) {
      if (value?.file) {
        formData.append(key, value?.file);
      } else {
        if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value ? value : "");
        }
      }
    }
    formData.append("user_id", currentUser.id);

    await uploadFormPhd(formData);
    // setActiveStep(activeStep + 1);
  }

  const successSubmit = () => {
    Swal.fire({
      icon: "success",
      title: "Successfully",
      showConfirmButton: false,
      timer: 1500
    }).then((result) =>
      navigate(`/research-progress/${role}`, { replace: true })
    );
  };

  async function _handleSubmit(values, actions) {
    if (isLastStep) {
      await _submitForm(values, actions);
      successSubmit();
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }

  return (
    <Container>
      <Box>
        <>
          <Typography component="h1" variant="h4">
            PhD Progress Report
          </Typography>
          <FormControl>
            <Stepper activeStep={activeStep} sx={{ paddingTop: 6 }}>
              {steps?.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </FormControl>

          {/* {activeStep === steps.length ? (
              <>Test</>
            ) : ( */}
          <Formik
            initialValues={formInitialValues}
            validationSchema={currentValidationSchema}
            onSubmit={_handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form id={formId}>
                <Box sx={{ paddingTop: 6, paddingBottom: 6 }}>
                  {_renderStepContent(activeStep, pagePhd, role)}
                </Box>

                <Stack
                  direction="row"
                  justifyContent="space-evenly"
                  alignItems="center"
                  spacing={12}
                  sx={{ paddingTop: 3 }}
                >
                  {activeStep !== 0 && (
                    <Button
                      size="large"
                      variant="contained"
                      onClick={_handleBack}
                    >
                      Back
                    </Button>
                  )}
                  {activeStep === 0 && (
                    <Button
                      size="large"
                      variant="contained"
                      onClick={()=>{
                        navigate(`/research-progress/${role}`, { replace: true })
                      }}
                      // href={`/research-progress/${role}`}
                    >
                      Cancel
                    </Button>
                  )}
                  <LoadingButton
                    loading={isSubmitting}
                    size="large"
                    disabled={isSubmitting}
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    {isLastStep ? "Submit" : "Next"}
                  </LoadingButton>
                </Stack>
              </Form>
            )}
          </Formik>
          {/* )} */}
        </>
      </Box>
    </Container>
  );
}
